<template>
  <div style="padding:1em; width:50vw">
    <md-field :class="{'md-invalid': emailErr}" class="moow-input">
        <label>Email</label>
        <md-input v-model="username"></md-input>
        <span class="md-error">{{emailErr}}</span>

    </md-field>      
    <moow-input
      id="msg-input-txt-area"
      v-model="textAreaInput1"
      placeholder="Enter a message"
    ></moow-input>

    <moow-input-single
      id="msg-input-txt-area"
      v-model="input1"
      placeholder="Enter a message"
    ></moow-input-single>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "User input",
    },
    placeholder: String,
    modelValue: String || Number,
    disabled: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: "text",
    },
  },
  components: {},
  data() {
    return {
      input1: "",
      textAreaInput1: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
<style scoped lang="scss">
@import "../assets/styles/global.css";

.someClass {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/views/Components.vue